import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const offerRequestLeadWidget = {
        isLoading: false,
        init() {
            $(document).on('click', '.offer-request-send-btn', this, this.send);
			$(document).on('click', 'a[href="{request-offer}"]', this, this.openModal);
        },
		openModal(event) {
			const _this = event.data;
			event.preventDefault();

			if (_this.isLoading) {
				console.log('is loading...');
				return false;
			}

			_this.isLoading = true;
			let element = this;

			var moduleId = $(this).data('id');
			var artwork = $(this).data('artwork');

			$('#' + $(element).data('modal')).modal('show');
			$('#' + $(element).data('modal')).on('shown.bs.modal', function (e) {
				_this.isLoading = false;

				if (artwork != 'all') {
					$("#request-offer-artwork-"+moduleId+" option:not(:first)").remove();
					$("#request-offer-artwork-"+moduleId).append('<option value="'+artwork+'">'+artwork+'</option>');
				}
			});
		},
		send(event) {
			const _this = event.data;
			event.preventDefault();

			var moduleId = $(this).data('id');

			if (_this.isLoading) {
				console.log('is loading...');
                return false;
            }

			let errors = false;
			$('.offer-request-widget-form').find('.form-control').removeClass('is-invalid');
			$('.offer-request-widget-form').find('.form-check-input').removeClass('is-invalid');
			// $('#form-notifications').html('');

			if ($('#request-offer-name-' + moduleId).val() == '') {
				$('#request-offer-name-' + moduleId).addClass('is-invalid');
				errors = true;
			}
			if ($('#request-offer-email-' + moduleId).val() == '') {
				$('#request-offer-email-' + moduleId).addClass('is-invalid');
				errors = true;
			}
			if ($('#request-offer-phone-' + moduleId).val() == '') {
				$('#request-offer-phone-' + moduleId).addClass('is-invalid');
				errors = true;
			}
			if ($('#request-offer-artwork-' + moduleId + ' option:selected').val() == '') {
				$('#request-offer-artwork-' + moduleId).addClass('is-invalid');
				errors = true;
			}
			if (!$('#request-offer-terms-and-condition-' + moduleId).is(":checked")) {
				$('#request-offer-terms-and-condition-' + moduleId).addClass('is-invalid');
				errors = true;
			}

			if (errors) {
				// $('#form-notifications').html('<div class="alert alert-danger" role="alert">'+offerRequestErrorText+'</div>');
				return false;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = '&name=' + $('#request-offer-name-' + moduleId).val();
			values += '&email=' + $('#request-offer-email-' + moduleId).val();
			values += '&phone=' + $('#request-offer-phone-' + moduleId).val();
			values += '&artwork=' + $('#request-offer-artwork-' + moduleId + ' option:selected').val();
			values += '&message=' + $('#request-offer-message-' + moduleId).val();
			values += '&_token=' + $("meta[name='csrf-token']").attr("content");
			$.ajax({
	            type: "POST",
	            url: offerRequestRoutePost,
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
						for(var errorKey in response.errors) {
							if(!response.errors.hasOwnProperty(errorKey)) continue;
							for(var error in response.errors[errorKey]) {
								$("#request-offer-"+errorKey).addClass('is-invalid');
								errorHtml += response.errors[errorKey][error] + '<br>';
							}
						}

						//$('#bookings-form-error-msg').html(errorHtml);
                        //$('#bookings-form-error-msg').fadeIn();
						Swal.fire({
							//icon: "success",
							title: "Error!",
							html: errorHtml
						});
                        return false;
                    }

					if (response.status == 1) {
						$('.offer-request-widget-form').find('.form-control').val('');
						$('#request-offer-terms-and-condition-' + moduleId).prop('checked', false);
						$('#request-offer-modal-' + moduleId).modal('hide');

						Swal.fire({
							// icon: 'success',
							title: 'Success!',
							html: response.message
						});

						if (cookies_advertisement == 1) {
							//gtag('event', 'conversion', {'send_to': 'AW-732195211/z_5UCI7a8-cBEIvTkd0C'});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							//fbq('track', 'Lead');
						}

						// window.lintrk('track', { conversion_id: 9865345 });

						return false;
					}

					Swal.fire({
						// icon: 'success',
						title: 'Error!',
						html: response.message
					});
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		}
    };

    if ($('.offer-request-widget-form').length) {
        offerRequestLeadWidget.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/offer-request-lead-widget.js